import { gql } from "@apollo/client";export default gql`query MyQuery($id: Int!) {
    worksheet_block_by_pk(id: $id) {
        id
        worksheets {
            worksheet_id
        }
    }
}
`;
